import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SideBar from "../../../components/Sidebar";
import ProfileService from "../../../services/ProfileService";
import Swal from "sweetalert2";
import SubscriptionDialog from "../../../components/Dialogs/SubscriptionDialog";
import { useSubscriptionCheck } from "../../../hooks/useSubscriptionCheck";

const BankingServices = () => {
  const [stateName, setStateName] = useState("");

  const { premiumStatus, showDialog, setShowDialog, checkSubscriptionStatus } =
    useSubscriptionCheck();

  useEffect(() => {
    checkSubscriptionStatus(false);

    let storedState = localStorage.getItem("state");

    if (storedState) {
      setStateName(storedState);
    } else {
      fetchProfile();
    }
  }, []);

  const fetchProfile = async () => {
    try {
      const result = await ProfileService.fetch();

      if (!result.success) {
        Swal.fire("Oops!", result.message || "Request failed!", "error");
        return;
      }

      const res = result.data;

      if (res.status === "SUCCESS") {
        const state = res?.data?.state?.toUpperCase() || "";
        localStorage.setItem("state", state);
        setStateName(state);
      } else {
        Swal.fire("Oops!", res.message || "Something went wrong", "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Network error",
        "error",
      );
    }
  };

  const services = [
    // {
    //   name: "BC Agent Onboarding & E-KYC",
    //   href: "/bc-agent-onboarding",
    //   icon: "/assets/images/new-account-icon.png",
    //   requiresSubscription: true,
    // },
    // {
    //   name: "Fino Money Transfer",
    //   href: "/fino-money-transfer",
    //   icon: "/assets/images/money-transfer-icon.png",
    //   requiresSubscription: true,
    // },
    // {
    //   name: "UPI Cash Point",
    //   href: "/upi-cash-point",
    //   icon: "/assets/images/upi-cash-point-logo.png",
    //   requiresSubscription: true,
    // },
    // {
    //   name: "Cash Management Services (CMS)",
    //   href: "/cms",
    //   icon: "/assets/images/cms-icon.png",
    //   requiresSubscription: true,
    // },
    {
      name: "Order Mantra Device",
      href: "/mantra-device",
      icon: "/assets/images/mantra-device-1.png",
      requiresSubscription: false, // ✅ FREE
    },
  ];

  //  // ✅ Add Fino CSP only for West Bengal
  // if (stateName === "WEST BENGAL") {
  //   services.push({
  //     name: "Fino Payments Bank CSP",
  //     href: "/fino-csp-landing",
  //     icon: "/assets/images/fino-logo.png",
  //     requiresSubscription: false, // ✅ FREE
  //   });
  // }

  // ✅ Click Handler
  const handleClick = (service, e) => {
    if (!service.requiresSubscription) return;

    if (premiumStatus !== "true") {
      e.preventDefault(); // stop navigation
      setShowDialog(true);
    }
  };

  return (
    <div className="container-fluid mt-3">
      <div className="row">
        <SideBar />

        <div className="col-md-9 mb-3">
          <div className="card mb-4 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Banking & Financial Services</h5>

              <div className="row my-4">
                {services.map((service, index) => (
                  <div key={index} className="col-6 col-sm-4 col-md-3 col-lg-2">
                    <Link
                      to={service.href}
                      className="text-decoration-none"
                      onClick={(e) => handleClick(service, e)}
                    >
                      <div className="card h-100 border-0 shadow-sm text-center p-3 service-card">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                          style={{
                            width: "80px",
                            height: "80px",
                            background:
                              "linear-gradient(135deg, #e3f2fd, #ffffff)",
                          }}
                        >
                          <img
                            src={service.icon}
                            alt={service.name}
                            style={{
                              width: "45px",
                              height: "45px",
                              objectFit: "contain",
                            }}
                          />
                        </div>

                        <div
                          className="fw-semibold"
                          style={{ fontSize: "15px", color: "#333" }}
                        >
                          {service.name}
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Subscription Dialog */}
      <SubscriptionDialog
        show={showDialog}
        onHide={() => setShowDialog(false)}
        serviceName="Banking Services"
      />

      <style jsx>{`
        .service-card {
          transition: all 0.3s ease;
          border-radius: 16px;
        }

        .service-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
        }
      `}</style>
    </div>
  );
};

export default BankingServices;
